import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { TestimonialsCarousel } from './components/TestimonialsCarousel';
import { ProductPreview } from './components/ProductPreview';
import { PriceSection } from './components/PriceSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
function MetaPixel() {
  useEffect(() => {
    document.title = 'Libre de SIBO - Plan de 21 días';
  }, []);
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '892577757067744');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=892577757067744&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return null;
}
function Footer() {
  return <footer className="bg-brand-bg-beige py-8 border-t border-brand-bg-cream" data-id="element-0">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1">
        <p className="text-brand-text-medium text-sm mb-2" data-id="element-2">
          © 2026 Libre de SIBO – Todos los derechos reservados
        </p>
        <p className="text-brand-text-medium/70 text-xs" data-id="element-3">
          Producto digital. Resultados pueden variar según cada persona.
        </p>
      </div>
    </footer>;
}
export function App() {
  return <div className="min-h-screen bg-brand-bg-white font-inter selection:bg-brand-green selection:text-white" data-id="element-4">
      <MetaPixel data-id="element-5" />
      <CountdownBar data-id="element-6" />
      <main data-id="element-7">
        <HeroSection data-id="element-8" />
        <ProblemSection data-id="element-9" />
        <SolutionSection data-id="element-10" />
        <IncludesSection data-id="element-11" />
        <ProductPreview data-id="element-12" />
        <TestimonialsCarousel data-id="element-13" />
        <PriceSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
        <FAQSection data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}